const ARTS_COLOR_FALLBACKS = {
  A: '#CB3333',
  R: '#2B6CB0',
  T: '#1EB050',
  S: '#DCC23A',
};

const ARTS_KEYS = ['A', 'S', 'T', 'R'];

const getCssVar = (name) => {
  if (typeof window === 'undefined') {
    return '';
  }

  return getComputedStyle(document.documentElement)
    .getPropertyValue(name)
    .trim();
};

const getArtsColors = () => ({
  A: getCssVar('--arts-a') || ARTS_COLOR_FALLBACKS.A,
  R: getCssVar('--arts-r') || ARTS_COLOR_FALLBACKS.R,
  T: getCssVar('--arts-t') || ARTS_COLOR_FALLBACKS.T,
  S: getCssVar('--arts-s') || ARTS_COLOR_FALLBACKS.S,
});

const hexToRgba = (hexColor, opacity) => {
  const hex = hexColor.replace('#', '');
  const value = hex.length === 3
    ? hex
        .split('')
        .map((char) => `${char}${char}`)
        .join('')
    : hex;

  const red = parseInt(value.slice(0, 2), 16);
  const green = parseInt(value.slice(2, 4), 16);
  const blue = parseInt(value.slice(4, 6), 16);

  return `rgba(${red}, ${green}, ${blue}, ${opacity})`;
};

export { ARTS_COLOR_FALLBACKS, ARTS_KEYS, getArtsColors, hexToRgba };
